/**
 * Enum para os papéis dos participantes no chat
 */
export enum ParticipantRole {
  TERAPEUTA = 'Terapeuta',
  OBSERVADOR = 'Observador',
  CONSTELADO = 'Constelado'
}

/**
 * Interface para mensagem do chat
 */
export interface ChatMessage {
  id: string;
  senderId: string;
  senderName: string;
  senderRole: ParticipantRole;
  receiverId: string;
  receiverName: string;
  receiverRole: ParticipantRole;
  message: string;
  timestamp: Date;
  read?: boolean;
  readAt?: Date;
}

/**
 * Interface para os dados de envio de mensagem
 */
export interface SendMessageData {
  senderId: string;
  senderName: string;
  senderRole: ParticipantRole;
  receiverId: string;
  receiverName: string;
  receiverRole: ParticipantRole;
  message: string;
}
